import { Card } from "@/src/components";
import { useDaoVotes } from "@/src/hooks/useVotes";
import { Timer } from "@/src/components/deadlineTimer";
import { fmt } from "@/src/lib/utils";

export const DaoVoteBalance = () => {
  const { yes,no,deadline } = useDaoVotes();
  return (
    <Card>
      <div className="space-y-1 mb-4">
        <h2 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">Vote Results</h2>
      </div>
      <div className="space-y-0 divide-y divide-border/50">
        <div className="flex items-center justify-between py-2.5">
          <span className="text-sm text-muted-foreground">YES votes</span>
          <span className="text-lg sm:text-2xl font-bold text-success font-mono">
            {fmt(yes, 0)}
          </span>
        </div>
        <div className="flex items-center justify-between py-2.5">
          <span className="text-sm text-muted-foreground">NO votes</span>
          <span className="text-lg sm:text-2xl font-bold text-destructive font-mono">
            {fmt(no, 0)}
          </span>
        </div>
        <div className="flex items-center justify-between py-2.5">
          <span className="text-sm text-muted-foreground">Deadline</span>
          <span className="text-lg sm:text-2xl font-bold text-primary font-mono tracking-wider">
            {parseInt(deadline) > 0 ? <Timer time={parseInt(deadline)}/> : "00:00:00:00"}
          </span>
        </div>
      </div>
    </Card>

  );
};
